export const AllRole = ['OWNER', 'ADMIN', 'MEMBER', 'USER'];
export const OnlyOwner = ['OWNER'];
export const OnlyAdmin = ['ADMIN'];
export const OwnerAdmin = ['OWNER', 'ADMIN'];
export const AllExceptOwner = ['ADMIN', 'MEMBER', 'USER'];
export const UserAdmin = ['ADMIN', 'USER'];